import React from "react";
import { useTranslation } from "react-i18next";

interface LiveIndicatorProps {
  className?: string;
}

export function LiveIndicator({ className }: LiveIndicatorProps) {
  const { t } = useTranslation("liveblog");

  return (
    <div className={`tik4-sbli ${className || ""}`}>
      <div className="tik4-sbli__i"></div>
      <div className="tik4-sbli__l">
        <span className="tik4-sbli__l__t">
          {t("liveblog.sport.scoreboard.live.label")}
        </span>
      </div>
    </div>
  );
} 